// import React, { useState } from "react";
// import "./SignUp.css"; // Import the CSS file
// // import "../../../src/App.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { IoMdClose, IoMdCloseCircle } from "react-icons/io";
// import { GiCombinationLock } from "react-icons/gi";
// import {
//   FaMobileAlt,
//   FaCaretDown,
//   FaUser,
//   FaEye,
//   FaEyeSlash,
// } from "react-icons/fa"; // Import icons
// import axios from "axios";
// import apiBaseUrl from "../../config/config";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../AuthContext";

// const SignUp = (props) => {
//   const navigate = useNavigate();
//   const { signup } = useAuth();

//   const [formData, setFormData] = useState({
//     site_code: apiBaseUrl.sitecodes,
//     user_name: "",
//     password: "",
//     user_type: "User",
//     master_id: apiBaseUrl.superAdmin,
//     refercode: "",
//     otp: "",
//   });

//   const [showPopup, setShowPopup] = useState(false);
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false); // State to toggle password visibility
//   const [otpBtn, setOtpBtn] = useState(false); // State to toggle password visibility

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     if (confirmPassword !== formData.password) {
//       toast.error("Password Not Matched!", { autoClose: 2000 });
//       return false;
//     }
//     if (!formData?.otp) {
//       toast.error("Otp Not Matched!", { autoClose: 2000 });
//       return false;
//     }

//     var config = {
//       method: "post",
//       url: `${apiBaseUrl.apiUrl}users/addUsers`,
//       headers: {
//         "Content-Type": "application/json",
//       },

//       data: JSON.stringify(formData),
//     };
//     axios(config)
//       .then(function (response) {
//         if (response.data.result) {
//           toast.success("Registered successful!", { autoClose: 2000 });

//           // localStorage.setItem(
//           //   "userdata",
//           //   JSON.stringify(response.data.resultData)
//           // );
//           console.log("response.data.resultData", response.data.resultData);
//           signup(response.data.resultData[0]);

//           // setTimeout(() => {
//           //   props?.toggleSignUpPopup(false);
//           //   props?.handleClose();
//           // }, 1000);
//           if (props?.togglePopup) {
//             props.togglePopup("Yes");
//           }
//           if (props?.handleClose) {
//             props.handleClose();
//           }
//         } else {
//           toast.error(response.data.resultMessage, { autoClose: 2000 });
//         }
//       })
//       .catch(function (error) {
//         console.log(error);
//         toast.error("An error occurred during registering", {
//           autoClose: 2000,
//         });
//       });
//   };

//   const togglePopup = () => {
//     setShowPopup(!showPopup);
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword); // Toggle between showing and hiding password
//   };
//   const toggleConfirmPasswordVisibility = () => {
//     setShowConfirmPassword(!showConfirmPassword); // Toggle between showing and hiding password
//   };

//   function getOtp() {
//     setOtpBtn(true);
//     var config = {
//       method: "post",
//       url: `${apiBaseUrl.apiUrl}otps/sendOtp`,
//       headers: {
//         "Content-Type": "application/json",
//       },
//       data: JSON.stringify({
//         user_name: formData.user_name,
//         site_code: apiBaseUrl.sitecodes,
//       }),
//     };
//     axios(config)
//       .then(function (response) {
//         if (response.data.result) {
//           toast.success("OTP Send successful!", { autoClose: 2000 });
//         } else {
//           toast.error(response.data.resultMessage, { autoClose: 2000 });
//         }
//         setOtpBtn(false);
//       })
//       .catch(function (error) {
//         console.log(error);
//         toast.error("An error occurred during sending OTP", {
//           autoClose: 2000,
//         });
//         setOtpBtn(false);
//       });
//   }

//   return (
//     <>
//       {/* Login Button */}
//       {/* <button type="button" className="btn btn-warning" onClick={togglePopup}>Sign Up</button> */}
//       {/* <button className="pushable-signup submit-btn login-trigger " onClick={togglePopup}>
//         <span className="front-signup">Sign Up</span>
//       </button> */}

//       {/* Popup */}
//       {props?.showSignupPopup && (
//         <div className="login-popup-overlay fixed inset-0  bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50" onClick={props?.toggleSignUpPopup}>
//           <div
//             className="login-popup-content"
//             onClick={(e) => e.stopPropagation()}
//           >
//             {/* <span className="close-btn">
//               <IoMdCloseCircle onClick={props?.toggleSignUpPopup} />
//             </span> */}
//             <span
//               className="absolute top-2 right-2 p-1 text-black hover:text-gray-800 cursor-pointer transition-colors"
//               onClick={() => props?.toggleSignUpPopup()}
//             >
//               <IoMdClose className="w-5 h-5" />
//             </span>

//             <div className="login-popup-logo ">
//               <h5 className="text-black text-center font-bold text-[20px]">
//                 SignUp
//               </h5>
//             </div>
//             <form className=" text-[#000]" onSubmit={handleSubmit}>
//               {/* <div className="phnumber-signup" style={{ borderRadius: "8px" }}>
//                 <span className="relative country-code">+91</span>
//                 <input
//                   type="number"
//                   name="user_name"
//                   style={{ width: "100%", }}
//                   value={formData.user_name}
//                   onChange={(e) => handleInputChange(e)}
//                   placeholder="Enter Your 10 Digit Number"
//                   className="phnumber absoulute left-0"
//                   required
//                 /> */}
//               <span className="text-black w-[281px] ml-2">Phone Number</span>
//               <div className="relative border border-gray-300 rounded-lg overflow-hidden mb-3">
//                 {/* Country Code Badge */}
//                 <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-600 z-10">
//                   +91
//                 </span>

//                 {/* Phone Number Input */}
//                 <input
//                   type="number"
//                   name="user_name"
//                   value={formData.user_name}
//                   onChange={(e) => handleInputChange(e)}
//                   placeholder="Enter Your 10 Digit Number"
//                   className="w-full pl-12 pr-24 py-2 focus:outline-none"
//                   required
//                 />

//                 {/* Get OTP Button */}
//                 <button
//                   className="getotp p-1 bg-[#5ecbdd] bg-gradient-to-b from-[#5ecbdd] to-[#146578] border border-[#72bbef] rounded-[10px] absolute top-1/2 right-2 transform -translate-y-1/2 text-white text-xs md:text-sm w-16 md:w-20"
//                   disabled={otpBtn}
//                   onClick={(e) => getOtp(e)}
//                 >
//                   Get OTP
//                 </button>
//               </div>

//               {/* </div> */}
//               <div className="signup-otp">
//                 <input
//                   type="number"
//                   name="otp"
//                   value={formData.otp}
//                   onChange={(e) => handleInputChange(e)}
//                   placeholder="Enter OTP"
//                   className="otp-input "
//                   style={{ borderRadius: "8px", height: "43px" }}
//                 />
//               </div>
//               <div className="relative mb-3">
//                 <span className="text-black w-[281px] ml-2">Password</span>
//                 <div className="flex items-center border border-gray-300 rounded-lg h-[43px]">
//                   {/* Lock Icon */}
//                   <div className="pl-3 pr-2 text-yellow-500">
//                     <GiCombinationLock size={20} />
//                   </div>

//                   {/* Password Input */}

//                   <input
//                     className="flex-1 py-2 pr-10 focus:outline-none border-none"
//                     type={showPassword ? "text" : "password"}
//                     name="password"
//                     placeholder="Password"
//                     required
//                     value={formData.password}
//                     onChange={(e) => handleInputChange(e)}
//                   />

//                   {/* Eye Toggle Button */}
//                   <button
//                     type="button"
//                     className="px-3 text-gray-500 hover:text-gray-700 focus:outline-none"
//                     onClick={togglePasswordVisibility}
//                   >
//                     {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
//                   </button>
//                 </div>
//               </div>
//               <div className="relative mb-3">
//                 <span className="text-black w-[281px] ml-2">Confirm Password</span>
//                 <div className="flex items-center border border-gray-300 rounded-lg h-[43px]">
//                   {/* Lock Icon */}
//                   <div className="pl-3 pr-2 text-yellow-500">
//                     <GiCombinationLock size={20} />
//                   </div>

//                   {/* Confirm Password Input */}
//                   <input
//                     className="flex-1 py-2 pr-10 focus:outline-none border-none"
//                     type={showConfirmPassword ? "text" : "password"}
//                     name="confirmpass"
//                     placeholder="Confirm Password"
//                     required
//                     value={confirmPassword}
//                     onChange={(e) => setConfirmPassword(e.target.value)}
//                   />

//                   {/* Eye Toggle Button */}
//                   <button
//                     type="button"
//                     className="px-3 text-gray-500 hover:text-gray-700 focus:outline-none"
//                     onClick={toggleConfirmPasswordVisibility}
//                   >
//                     {showConfirmPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
//                   </button>
//                 </div>
//               </div>

//               {/* <div className="signup-password" style={{ borderRadius: "8px", height: "43px" }}>
//                 <GiCombinationLock
//                   size={20}
//                   color="#e9b02e"
//                   style={{ marginRight: 0, marginLeft: 5 }}
//                 />
//                 <input
//                   className="password-input"
//                   type={showConfirmPassword ? "text" : "password"} // Toggle between 'text' and 'password'
//                   name="confirmpass"
//                   placeholder="Confirm Password"
//                   required
//                   value={confirmPassword}
//                   onChange={(e) => setConfirmPassword(e.target.value)}
//                   style={{ marginTop: "0px" }}
//                 />
//                 <span
//                   className="confirm-password-toggle-signup mr-1"
//                   onClick={toggleConfirmPasswordVisibility}
//                 >
//                   {showConfirmPassword ? (
//                     <FaEyeSlash size={20} />
//                   ) : (
//                     <FaEye size={20} />
//                   )}
//                 </span>{" "}

//               </div> */}
//               {/* <div className="signup-password" style={{ borderRadius: "8px", height: "43px" }}>
//                 <GiCombinationLock
//                   size={20}
//                   color="#e9b02e"
//                   style={{ marginRight: 0, marginLeft: 5 }}
//                 />
//                 <input
//                   className="password-input"
//                   type={showPassword ? "text" : "password"} // Toggle between 'text' and 'password'
//                   name="password"
//                   placeholder="Password"
//                   required
//                   value={formData.password}
//                   onChange={(e) => handleInputChange(e)}
//                   style={{ marginTop: "0px" }}
//                 />
//                 <span
//                   className="password-toggle-signup mr-1"
//                   onClick={togglePasswordVisibility}
//                 >
//                   {showPassword ? (
//                     <FaEyeSlash size={20} />
//                   ) : (
//                     <FaEye size={20} />
//                   )}
//                 </span>{" "}

//           </div> */}

//               <span className="text-black w-[281px] ml-2">Referral</span>
//               <input
//                 type="text"
//                 name="refercode"
//                 placeholder="Referral Code (if any)"
//                 value={formData.refercode}
//                 onChange={(e) => handleInputChange(e)}
//                 style={{ height: "35px", borderRadius: "8px" }}
//               />
//               <div className="form-check">
//                 <input
//                   className="form-check-input"
//                   type="checkbox"
//                   value=""
//                   id="flexCheckDefault"
//                 />
//                 <label className="form-check-label text-black font-medium" for="flexCheckDefault">
//                   Remember me
//                 </label>
//               </div>
//               <button type="submit" className=" w-[291px] mt-3 ml-2 flex items-center justify-center text-[16px] rounded-[3px] h-[40px] px-[10px] pt-[3px] pb-[5px] border border-[#065265] bg-gradient-to-b from-[#6fe3f5] to-[#065265] text-white shadow-sm transition-all duration-200"
//                 style={{ textShadow: "0 1px 1px rgba(0,0,0,0.5)", marginTop: 10 }}>
//                 <span className="front">Register</span>
//               </button>
//               <span className="other-login text-black">Or register with</span>
//               <span className="other-button">
//                 {/* <button className="google border border-gray-500">
//                   <div className="flex justify-center items-center">
//                     <img
//                       src="./Images/google.png"
//                       alt=""
//                       className="google-image"
//                     />
//                     <span className="text-[#fff]">Google</span>
//                   </div>
//                 </button> */}
//                 <button
//                   className="whatsapp"
//                   onClick={() => props?.openWhatsApp(props?.whatsappNum)}
//                 >
//                   <div className="flex justify-center items-center">
//                     <img
//                       src="./Images/whatsapp.png"
//                       alt=""
//                       className="whatsapp-image"
//                     />
//                     <span className="text-[#fff]">WhatsApp</span>
//                   </div>
//                 </button>
//               </span>
//               <span
//                 className="new-account text-black"
//                 onClick={() => props?.togglePopup()}
//               >
//                 Already have an account? Login
//               </span>{" "}
//               {/* Added onClick event */}
//             </form>
//           </div >
//         </div >
//       )}
//     </>
//   );
// };

// export default SignUp;


import React, { useState } from "react";
import "./SignUp.css"; // Import the CSS file
// import "../../../src/App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoMdClose, IoMdCloseCircle } from "react-icons/io";
import { GiCombinationLock } from "react-icons/gi";
import {
  FaMobileAlt,
  FaCaretDown,
  FaUser,
  FaEye,
  FaEyeSlash,
  FaDownload, // Import the download icon
} from "react-icons/fa"; // Import icons
import axios from "axios";
import apiBaseUrl from "../../config/config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

const SignUp = (props) => {
  const navigate = useNavigate();
  const { signup } = useAuth();

  const [formData, setFormData] = useState({
    site_code: apiBaseUrl.sitecodes,
    user_name: "",
    password: "",
    user_type: "User",
    master_id: apiBaseUrl.superAdmin,
    refercode: "",
    otp: "",
  });

  const [showPopup, setShowPopup] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // State to toggle password visibility
  const [otpBtn, setOtpBtn] = useState(false); // State to toggle password visibility 

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (confirmPassword !== formData.password) {
      toast.error("Password Not Matched!", { autoClose: 2000 });
      return false;
    }
    if (!formData?.otp) {
      toast.error("Otp Not Matched!", { autoClose: 2000 });
      return false;
    }

    var config = {
      method: "post",
      url: `${apiBaseUrl.apiUrl}users/addUsers`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(formData),
    };
    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success("Registered successful!", { autoClose: 2000 });
          console.log("response.data.resultData", response.data.resultData);
          signup(response.data.resultData[0]);

          if (props?.togglePopup) {
            props.togglePopup("Yes");
          }
          if (props?.handleClose) {
            props.handleClose();
          }
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
        toast.error("An error occurred during registering", {
          autoClose: 2000,
        });
      });
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword); // Toggle between showing and hiding password
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword); // Toggle between showing and hiding password
  };

  function getOtp() {
    setOtpBtn(true);
    var config = {
      method: "post",
      url: `${apiBaseUrl.apiUrl}otps/sendOtp`,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        user_name: formData.user_name,
        site_code: apiBaseUrl.sitecodes,
      }),
    };
    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success("OTP Send successful!", { autoClose: 2000 });
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
        setOtpBtn(false);
      })
      .catch(function (error) {
        console.log(error);
        toast.error("An error occurred during sending OTP", {
          autoClose: 2000,
        });
        setOtpBtn(false);
      });
  }

  return (
    <>
      {props?.showSignupPopup && (
        <div className="login-popup-overlay fixed inset-0 bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50" onClick={props?.toggleSignUpPopup}>
          <div
            className="login-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <span
              className="absolute top-2 right-2 p-1 text-black hover:text-gray-800 cursor-pointer transition-colors"
              onClick={() => props?.toggleSignUpPopup()}
            >
              <IoMdClose className="w-5 h-5" />
            </span>

            <div className="login-popup-logo ">
              <h5 className="text-black text-center font-bold text-[20px]">
                SignUp
              </h5>
            </div>
            <form className=" text-[#000]" onSubmit={handleSubmit}>
              <span className="text-black w-[281px] ml-2">Phone Number</span>
              <div className="relative border border-gray-300 rounded-lg overflow-hidden mb-3">
                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-600 z-10">
                  +91
                </span>
                <input
                  type="number"
                  name="user_name"
                  value={formData.user_name}
                  onChange={(e) => handleInputChange(e)}
                  placeholder="Enter Your 10 Digit Number"
                  className="w-full pl-12 pr-24 py-2 focus:outline-none"
                  required
                />
                <button
                  className="getotp p-1 bg-[#5ecbdd] bg-gradient-to-b from-[#5ecbdd] to-[#146578] border border-[#72bbef] rounded-[10px] absolute top-1/2 right-2 transform -translate-y-1/2 text-white text-xs md:text-sm w-16 md:w-20"
                  disabled={otpBtn}
                  onClick={(e) => getOtp(e)}
                >
                  Get OTP
                </button>
              </div>
              <div className="signup-otp">
                <input
                  type="number"
                  name="otp"
                  value={formData.otp}
                  onChange={(e) => handleInputChange(e)}
                  placeholder="Enter OTP"
                  className="otp-input "
                  style={{ borderRadius: "8px", height: "43px" }}
                />
              </div>
              <div className="relative mb-3">
                <span className="text-black w-[281px] ml-2">Password</span>
                <div className="flex items-center border border-gray-300 rounded-lg h-[43px]">
                  <div className="pl-3 pr-2 text-yellow-500">
                    <GiCombinationLock size={20} />
                  </div>
                  <input
                    className="flex-1 py-2 pr-10 focus:outline-none border-none"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    required
                    value={formData.password}
                    onChange={(e) => handleInputChange(e)}
                  />
                  <button
                    type="button"
                    className="px-3 text-gray-500 hover:text-gray-700 focus:outline-none"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                  </button>
                </div>
              </div>
              <div className="relative mb-3">
                <span className="text-black w-[281px] ml-2">Confirm Password</span>
                <div className="flex items-center border border-gray-300 rounded-lg h-[43px]">
                  <div className="pl-3 pr-2 text-yellow-500">
                    <GiCombinationLock size={20} />
                  </div>
                  <input
                    className="flex-1 py-2 pr-10 focus:outline-none border-none"
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmpass"
                    placeholder="Confirm Password"
                    required
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="px-3 text-gray-500 hover:text-gray-700 focus:outline-none"
                    onClick={toggleConfirmPasswordVisibility}
                  >
                    {showConfirmPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                  </button>
                </div>
              </div>

              <span className="text-black w-[281px] ml-2">Referral</span>
              <input
                type="text"
                name="refercode"
                placeholder="Referral Code (if any)"
                value={formData.refercode}
                onChange={(e) => handleInputChange(e)}
                style={{ height: "35px", borderRadius: "8px" }}
              />
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
                <label className="form-check-label text-black font-medium" htmlFor="flexCheckDefault">
                  Remember me
                </label>
              </div>
              <button type="submit" className=" w-[291px] mt-3 ml-2 flex items-center justify-center text-[16px] rounded-[3px] h-[40px] px-[10px] pt-[3px] pb-[5px] border border-[#065265] bg-gradient-to-b from-[#6fe3f5] to-[#065265] text-white shadow-sm transition-all duration-200"
                style={{ textShadow: "0 1px 1px rgba(0,0,0,0.5)", marginTop: 10 }}>
                <span className="front">Register</span>
              </button>
              <span className="other-login text-black">Or register with</span>
              <span className="other-button">

                {/* START: ADDED DOWNLOAD BUTTON */}
                {/* <a
                  href="/website-source.zip" // Link to the file in the /public folder
                  download="website-source.zip" // This attribute triggers the download
                  className="whatsapp" // Re-using your existing style for consistency
                  style={{ textDecoration: 'none' }} // Remove underline from the link
                >
                  <div className="flex justify-center items-center">
                    <FaDownload className="whatsapp-image" style={{ padding: '2px' }} />
                    <span className="text-[#fff]">Download App</span>
                  </div>
                </a> */}
                {/* END: ADDED DOWNLOAD BUTTON */}

                <button
                  className="whatsapp"
                  onClick={() => props?.openWhatsApp(props?.whatsappNum)}
                >
                  <div className="flex justify-center items-center">
                    <img
                      src="./Images/whatsapp.png"
                      alt=""
                      className="whatsapp-image"
                    />
                    <span className="text-[#fff]">WhatsApp</span>
                  </div>
                </button>
              </span>
              <span
                className="new-account text-black"
                onClick={() => props?.togglePopup()}
              >
                Already have an account? Login
              </span>{" "}
            </form>
          </div >
        </div >
      )}
    </>
  );
};

export default SignUp;
